import React,{useState,useEffect} from 'react';
import './Homepage.css';
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import EngineeringIcon from '@mui/icons-material/Engineering';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import CountUp from 'react-countup';
import ScrollTrigger from 'react-scroll-trigger';
import AOS from 'aos';


const HomepageFourthSection = () => {
  useEffect(()=>{
    AOS.init();
    window.scroll(0,0)
  },[]);

    const [counter,setCounter]=useState(false);
  return (
    <ScrollTrigger onEnter={()=>setCounter(true)} onExit={()=>setCounter(false)}>
      <div className="container-fluid" id='homepage-fourth-section' data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
<div className="row top-heading-row">
       <h1>Our Achievement</h1>
       <p>
       "Unique Technologies has successfully implemented cutting-edge PLC, HMI, SCADA solutions, leading advancements in solar water pump and street light automation, enhancing efficiency and sustainability across diverse industries."</p>
<hr />
</div>
<div className="row data-row">
    <div className="col" >
        <h1><HistoryToggleOffIcon style={{fontSize:"5rem"}}/></h1>
        <h2>{counter && <CountUp start={0} end={13} duration={3} delay={0} />}+</h2>
        <h3>Years In 
            <br />Business</h3>
    </div>
    <div className="col">
    <h1><EngineeringIcon style={{fontSize:"5rem"}}/></h1>
    <h2>{counter && <CountUp start={0} end={500} duration={3} delay={0} />}+</h2>
    <h3>Projects Completed
        <br />
Successfully</h3>
    </div>
    <div className="col">
    <h1><DoneOutlineIcon style={{fontSize:"5rem"}}/></h1>
    <h2>{counter && <CountUp start={0} end={97} duration={3} delay={0} />}%</h2>
    <h3>
Customer's
<br />Positive Feedback</h3>
    </div>
</div>
</div>
</ScrollTrigger>
  )
}

export default HomepageFourthSection
